import ParentStyled from '@/modules/LogsManagement/style';
import { useTheme } from '@material-ui/core/styles';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_LOGBOOK_DATE } from 'globalconfig/constants/static';
import { getNewObject, hasEnabledFeature, hasRestrictedRole, isDriver, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { subTabFields, tabValuesComponentFields, tenantMapping } from './config';
import { checkServiceProvider } from './serviceProviderConfig';
import useOptions from './useOptions';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const config = loadPageConfig();
const Component = lazy(() => import(`@/${config.logsList[0].name}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));
const Styled = loadStyle(ParentStyled, 'modules/LogsManagement');

const Index = (parentProps) => {
  const { manageLogList, fetchLogList, getFilters } = parentProps;
  const [pagination, setPagination] = useState(false);
  const history = useHistory();
  const i18n = useTranslation();
  const theme = useTheme();
  const commonParentProps = { history, i18n, Styled, theme };
  const [selectedIndex, setSelectedIndex] = useState(0);

  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;

  const setSelectedIndexfn = (index) => {
    const rowLen = checkServiceProvider('rowLen', SERVICE_PROVIDER, false);
    const wl = checkServiceProvider('wl', SERVICE_PROVIDER, false);
    setSelectedIndex(wl + rowLen * index);
  };

  useEffect(() => {
    fetchLogList({ apiId: 'fetchLoglistApiId' });
    getFilters({ apiId: 'fetchFilters' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (document.getElementById('list1')) {
      const isSelected = document.getElementById('list1')?.className.includes('Mui-selected');
      document.getElementById('list1').className = !isSelected
        ? document.getElementById('list1').className + ' Mui-selected'
        : document.getElementById('list1').className;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document.getElementById('list1')]);

  return (
    <RenderComponent
      {...config.logsList[0]}
      parentProps={parentProps}
      commonParentProps={commonParentProps}
      component={Component}
      history={history}
      i18n={i18n}
      list={manageLogList}
      selectedIndex={selectedIndex}
      setSelectedIndexfn={setSelectedIndexfn}
      pagination={pagination}
      setPagination={setPagination}
    />
  );
};

const RenderComponent = ({
  name,
  props,
  commonProps,
  title,
  parentProps,
  commonParentProps,
  component,
  history,
  i18n,
  verticalTab,
  selectedIndex,
  setSelectedIndexfn,
  pagination,
  setPagination,
  ...rest
}) => {
  const Component = component;
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;

  const [isToolsClicked, setIsToolsClicked] = useState(false);

  const handleChange = (event, newValue, fromSubTab) => {
    if (fromSubTab) history.push(subTabValues[newValue].url);
    else history.push(tabValues[newValue].url);
  };

  const { actions } = useOptions({ setIsToolsClicked, parentProps, setSelectedIndexfn });

  let newProps = props?.length ? getNewObject(parentProps, props) : {};
  newProps = {
    ...newProps,
    ...(commonProps?.length ? getNewObject(commonParentProps, commonProps) : {}),
    ...rest,
  };

  const selectedRow = (row) => {
    const day = moment(new Date(row.date)).format(UI_LOGBOOK_DATE);
    !hasRestrictedRole(['ADMIN']) &&
      history.push(`${pageUrls.logBook.replace(':id', row.idPub)}?driverId=${row.driverId}&logDay=${day}`);
  };

  const subTabValues = [
    {
      name: i18n.t('logs.manageLogsHeaderSigned'),
      value: (
        <Component
          selectedRow={(row, id) => selectedRow(row)}
          isDriverLogs={false}
          {...newProps}
          actions={actions}
          showExport
          isToolsClicked={isToolsClicked}
          setIsToolsClicked={setIsToolsClicked}
          selectedIndex={selectedIndex}
          pagination={pagination}
          setPagination={setPagination}
          fields={subTabFields}
        />
      ),
      url: pageUrls.logsList,
    },
    {
      name: i18n.t('logs.manageLogsHeaderUnSigned'),
      value: null,
      url: pageUrls.realTimeLogsList,
    },
  ];

  const tabValues = [
    ...(hasEnabledFeature('realTimeLogsEnabled')
      ? [
          {
            name: i18n.t('logs.manageLogsHeader'),
            value: (
              <>
                <Tab
                  data={subTabValues}
                  className={checkServiceProvider('tabvalues_classname', SERVICE_PROVIDER, false)}
                  currentTab={0}
                  noPadding
                  onChange={(event, newValue) => handleChange(event, newValue, true)}
                  vertical={checkServiceProvider('tabvalues_vertical', SERVICE_PROVIDER, false, { verticalTab })}
                />
              </>
            ),
            url: pageUrls.logsList,
          },
        ]
      : [
          {
            name: i18n.t('logs.manageLogsHeader'),
            value: (
              <>
                <Component
                  selectedRow={(row, id) => selectedRow(row)}
                  isDriverLogs={false}
                  {...newProps}
                  showExport
                  actions={actions}
                  isToolsClicked={isToolsClicked}
                  setIsToolsClicked={setIsToolsClicked}
                  selectedIndex={selectedIndex}
                  pagination={pagination}
                  setPagination={setPagination}
                  fields={tabValuesComponentFields}
                />
              </>
            ),
            url: pageUrls.logsList,
          },
        ]),

    ...(!isDriver()
      ? [
          {
            name: i18n.t('logs.undefinedDriverHeader'),
            value: null,
            url: pageUrls.logsUdList,
          },
          ...(tenantMapping.no_driver[SERVICE_PROVIDER] || tenantMapping.no_driver.default),
        ]
      : []),

    ...(tenantMapping[SERVICE_PROVIDER] || tenantMapping.default),
  ];

  return (
    <Styled.Content>
      <div className="goBack">
        <SvgIcon value={mediaUrls.pageBackButton} onClick={() => history.goBack()} />
      </div>
      <Tab data={tabValues} className="logwrapper" noPadding currentTab={0} onChange={handleChange} vertical={verticalTab} />
    </Styled.Content>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    manageLogList: state.manageLogList,
    filters: state.filters,
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchLogList: (data) => dispatch.manageLogList.fetchData(data),
    filterSuccess: (data) => dispatch.manageLogList.filterSuccess(data),
    setSelectedManageLogItem: (data) => dispatch.manageLogList.setSelectedItem(data),
    handleLogBookStatus: (data) => dispatch.logBookStatus.handleLogBookStatus(data),
    clearApiStatus: () => dispatch.asyncRequests.clearApiStatus(),
    getFilters: (data) => dispatch.filters.fetchData(data),
    viewReport: (data) => dispatch.viewReport.viewReportDocument(data),
  };
};

export default connect(mapState, mapDispatch)(Index);
Index.defaultTypes = {};
Index.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  manageLogList: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  handleLogBookStatus: PropTypes.func.isRequired,
  clearApiStatus: PropTypes.func.isRequired,
  setSelectedManageLogItem: PropTypes.func.isRequired,
  fetchUdLogList: PropTypes.func.isRequired,
  udFilterSuccess: PropTypes.func.isRequired,
  fetchUnAssignedEntries: PropTypes.func.isRequired,
  unAssignedEntries: PropTypes.object.isRequired,
  saveUnAssignedEntries: PropTypes.func.isRequired,
  setUdAssignEntryList: PropTypes.func.isRequired,
  clearUdAssignEntryListById: PropTypes.func.isRequired,
};
